import React, { useState, useLayoutEffect, useRef } from 'react';
import './Background.css';
import image1 from '../../Assets/image1.webp';

const Background = ({ PlayState, HeroCount, customImage }) => {
  const imgRef = useRef(null);
  const [imgStyle, setImgStyle] = useState({});

  useLayoutEffect(() => {
    const calculateStyle = () => {
      if (!imgRef.current) return;
      
      const img = imgRef.current;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const windowAspect = windowWidth / windowHeight;
      
      // Get image dimensions, defaulting to 16:9 if not yet loaded
      const imgWidth = img.naturalWidth || 1920;
      const imgHeight = img.naturalHeight || 1080;
      const imgAspect = imgWidth / imgHeight;

      let scale = 1.15;
      let positionY = '65%';

      // If window is portrait (mobile-ish) or image is much wider than window
      // This usually means we are cropping the sides (Height is constrained)
      if (windowAspect < imgAspect) {
         scale = 1.25;
         // When constrained by height, object-position Y has no effect (image height == window height).
         // We must use transform-origin to zoom into the bottom part.
         setImgStyle({
            transform: `scale(${scale})`,
            transformOrigin: `center 75%`,
            objectPosition: 'center center' // Reset object position as it doesn't help here
         });
      } else {
         // Window is wider than image (relative to height).
         // We are cropping top/bottom (Width is constrained).
         scale = 1.15;
         // Here object-position Y works because image is taller than window.
         setImgStyle({
            transform: `scale(${scale})`,
            transformOrigin: `center center`,
            objectPosition: `center 65%`
         });
      }
    };

    window.addEventListener('resize', calculateStyle);
    // Initial calculation
    calculateStyle();
    
    return () => window.removeEventListener('resize', calculateStyle);
  }, [customImage]);

  const onImgLoad = () => {
      // Trigger recalculation once image loads to get correct natural dimensions
      window.dispatchEvent(new Event('resize'));
  };

  if (PlayState) {
    return (
      <img 
        ref={imgRef}
        className='BackImage' 
        src={customImage || image1} 
        alt='Background' 
        onLoad={onImgLoad}
        style={imgStyle}
      />
    );
  } else {
    return null;
  }
}

export default Background;
